import { ClipboardCheck } from "@untitledui/icons";
import { useAppTranslation } from "@/hooks/use-app-translation";

type FormPreviewEmptyStateProps = {
	emptyKey: string;
};

export function FormPreviewEmptyState({
	emptyKey,
}: FormPreviewEmptyStateProps) {
	const { t } = useAppTranslation();
	const message = t(emptyKey);

	return (
		<div className="flex flex-col items-center justify-center gap-4 py-8 text-center">
			<div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
				<ClipboardCheck className="size-6 text-gray-500" aria-hidden />
			</div>
			{message ? <p className="text-sm text-gray-500">{message}</p> : null}
		</div>
	);
}
